<div class="container-fluid pt-3">
  Olog Messages
  <div class="mat-container">
    <mat-table #table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Message </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.name }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Active</mat-header-cell>
        <mat-cell *matCellDef="let element"
          ><mat-slide-toggle
            [(ngModel)]="element.status"
            [disabled]="true"
          ></mat-slide-toggle>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="from">
        <mat-header-cell *matHeaderCellDef> From Status </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [ngClass]="element.fromStatus?.class"
          >{{ element.fromStatus?.name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="to">
        <mat-header-cell *matHeaderCellDef> To Status </mat-header-cell>
        <mat-cell *matCellDef="let element" [ngClass]="element.toStatus?.class">
          {{ element.toStatus?.name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>
          <!-- US 6931: Add now requires Create Olog Message (154), matching the Update/Delete checks -->
          <button
            mat-icon-button
            color="accent"
            (click)="ologMessageDialog()"
            *ngIf="hasPrivilege(privilegeEnum.CreateOlogMessage) && !disabled"
          >
            <mat-icon>add</mat-icon>
          </button>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element; let elementIndex = index"
          class="pr-0"
        >
          <button
            mat-icon-button
            color="accent"
            (click)="ologMessageDialog(element)"
            *ngIf="
              hasPrivilege(privilegeEnum.UpdateOlogMessage) &&
              !disabled &&
              !element.action
            "
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            (click)="delete(element)"
            *ngIf="
              hasPrivilege(privilegeEnum.DeleteOlogMessage) &&
              !disabled &&
              !element.action
            "
          >
            <mat-icon>delete</mat-icon>
          </button>
          <mat-icon
            class="yellow material-symbols-outlined action-icon"
            *ngIf="element.action == actionPending.Update"
            >edit_square</mat-icon
          >
          <mat-icon
            class="red material-symbols-outlined action-icon"
            *ngIf="element.action == actionPending.Delete"
            >delete_forever</mat-icon
          >
          <mat-icon
            class="blue material-symbols-outlined action-icon"
            *ngIf="element.action == actionPending.Create"
            >add_box</mat-icon
          >
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [hidden]="row.deleteReason"
      ></mat-row>
    </mat-table>
  </div>
</div>
